export const ROW_GUTTER = 16;
export const SIDE_NAV_WIDTH = 250;
export const SIDE_NAV_COLLAPSED_WIDTH = 80;
export const HEADER_HEIGHT = 70;
export const FOOTER_HEIGHT = 60;
export const TOP_NAV_HEIGHT = 55;
export const SIDE_NAV_LIGHT = 'SIDE_NAV_LIGHT';
export const SIDE_NAV_DARK = 'SIDE_NAV_DARK';
export const NAV_TYPE_SIDE = 'SIDE';
export const NAV_TYPE_TOP = 'TOP';
export const DIR_LTR = 'ltr';
export const DIR_RTL = 'rtl';
export const CONTENT_MAX_WIDTH = 1400;
export const CONTENT_HEIGHT_OFFSET = HEADER_HEIGHT + FOOTER_HEIGHT;
export const HEADER_BG_DEFAULT_COLOR_LIGHT = '#ffffff';
export const HEADER_BG_DEFAULT_COLOR_DARK = '#042c70';
export const LAYOUT_CONTENT_GUTTER = 25;
export const LAYOUT_CONTENT_GUTTER_SM = 15;
export const SIDE_NAV_DARK_BG_COLOR = '#f3f5f9';

export const BLUE_BASE    = '#042c70';
export const PURPLE_BASE  = '#7c3aed';
export const CYAN_BASE    = '#0ca678';
export const GREEN_BASE   = '#2e9e5b';
export const MAGENTA_BASE = '#db2777';
export const PINK_BASE    = '#db2777';
export const RED_BASE     = '#e53935';
export const ORANGE_BASE  = '#f97316';
export const YELLOW_BASE  = '#fadb14';
export const VOLCANO_BASE = '#e53935';
export const GEEK_BLUE_BASE = '#3b82f6';
export const LIME_BASE    = '#65a30d';
export const GOLD_BASE    = '#f59e0b';

export const WHITE         = '#ffffff';
export const DARK          = '#000000';
export const GRAY_DARK     = '#0f1f3d';
export const GRAY          = '#3d4f6b';
export const GRAY_LIGHT    = '#7b8eaa';
export const GRAY_LIGHTER  = '#e4e8f0';
export const GRAY_LIGHTEST = '#f3f5f9';

export const BODY_BACKGROUND = '#f3f5f9';

export const FONT_SIZE_BASE = 14;

export const TEMPLATE = {
    HEADER_HEIGHT,
    FOOTER_HEIGHT,
    TOP_NAV_HEIGHT,
    CONTENT_HEIGHT_OFFSET,
    SIDE_NAV_WIDTH,
    SIDE_NAV_COLLAPSED_WIDTH,
    SIDE_NAV_DARK_BG_COLOR,
    CONTENT_MAX_WIDTH,
    HEADER_BG_DEFAULT_COLOR_LIGHT,
    HEADER_BG_DEFAULT_COLOR_DARK,
    LAYOUT_CONTENT_GUTTER,
    LAYOUT_CONTENT_GUTTER_SM,
    NAV_TYPE_SIDE,
    NAV_TYPE_TOP,
    SIDE_NAV_LIGHT,
    SIDE_NAV_DARK,
    DIR_LTR,
    DIR_RTL
}

export const THEME_COLOR = {
    BLUE:     BLUE_BASE,
    PURPLE:   PURPLE_BASE,
    CYAN:     CYAN_BASE,
    GREEN:    GREEN_BASE,
    MAGENTA:  MAGENTA_BASE,
    PINK:     PINK_BASE,
    RED:      RED_BASE,
    ORANGE:   ORANGE_BASE,
    YELLOW:   YELLOW_BASE,
    VOLCANO:  VOLCANO_BASE,
    GEEK_BLUE: GEEK_BLUE_BASE,
    LIME:     LIME_BASE,
    GOLD:     GOLD_BASE,
}

export const FONT_WEIGHT = {
    LIGHTER: 'lighter',
    LIGHT: 300,
    NORMAL: 400,
    SEMIBOLD: 500,
    BOLD: 'bold',
    BASE: 400,
    BOLDER: 'bolder'
}

export const FONT_SIZES = {
    BASE: FONT_SIZE_BASE,
    LG: FONT_SIZE_BASE + 2,
    SM: 12
}

export const SPACER = {
    0: '0',
    1: '0.25rem',
    2: '0.5rem',
    3: '1rem',
    4: '1.5rem',
    5: '3rem',
}

const BREAKPOINT = {
    xs: '480px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1400px',
    xxl: '1600px'
}

export const MEDIA_QUERIES = {
    DESKTOP: `(min-width: ${BREAKPOINT.xl})`,
    LAPTOP: `(max-width: ${BREAKPOINT.xxl})`,
    LAPTOP_ABOVE: `(min-width: ${BREAKPOINT.xxl})`,
    TABLET: `(max-width: ${BREAKPOINT.lg})`,
    MOBILE: `(max-width: ${BREAKPOINT.md})`,
}

export const BORDER = {
    BASE_COLOR: '#dde3ed'
}

export const GRAY_SCALE = {
    DARK,
    WHITE,
    GRAY_DARK,
    GRAY,
    GRAY_LIGHT,
    GRAY_LIGHTER,
    GRAY_LIGHTEST
}

export const DARK_MODE = {
    TEXT_COLOR:        '#b8c5d9',
    HEADING_COLOR:     '#d0dae8',
    BG_COLOR:          '#021b4a',
    BORDER_BASE_COLOR: '#3d6ab5',
    HOVER_BG_COLOR:    '#0d3990',
    ACTIVE_BG_COLOR:   '#1a4d9f',
    DROP_DOWN_SHADOW:  'none'
}
